import { ITrackMutation, ITrackMutationForm, TRACK_CENSORIOUS } from 'services/tracks/types';
import { trimTitle, trimTitles } from 'utils/global/mainTitle.utils';
import { unknownEnumValueConverter } from 'utils/global/valueConverter';
import { getArtistsWithRolePlacement } from './artistsWithRolePlacement';

export const trackFormToQuery = (trackForm: ITrackMutationForm): ITrackMutation => {
  const { mp3Link, mp3PreviewLink, wavLink, file, statistics, ...track } = {
    ...trackForm,
    source: 1,
    censorious: unknownEnumValueConverter<TRACK_CENSORIOUS>(trackForm.censorious),
    assignIsrc: trackForm.assignIsrc,
    genre: unknownEnumValueConverter<number>(trackForm.genre.id),
    artists: getArtistsWithRolePlacement(trackForm.artists),
    isrc: trackForm.assignIsrc ? null : (trackForm.isrc?.replaceAll('-', '') ?? null),
    cline: trackForm.cline?.name?.length ? trackForm.cline : null,
    pline: trackForm.pline?.name?.length ? trackForm.pline : null,
    contractRequests: trackForm.contracts.map(
      ({ contractId, divisionPercentage, startDate, endDate }) => ({
        contractId,
        divisionPercentage,
        startDate,
        endDate: endDate?.length ? endDate : null,
      }),
    ),
    mainTitle: trimTitle(trackForm.mainTitle),
    otherTitles: trimTitles(trackForm.otherTitles),
    language: trackForm.mainTitle.language,
  };

  return track;
};
